import { gql } from '@apollo/client'

/* WithdrawalInput + withdrawal no longer exist in backend schema */
export const WITHDRAW = gql`
  query withdrawalStub {
    __typename
  }
`
